import React, { useEffect, useRef, useState } from 'react'

const ArcadeEmbed = ({
	id,
	desktop = 'inline',
	mobile = 'inline',
	title = 'Interactive demo',
	ratio = 16 / 9,
	onEvent,
}) => {
	const ref = useRef(null)
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		if (!onEvent) return
		const handler = e => {
			if (e.origin !== 'https://demo.arcade.software' || !e.isTrusted) return
			onEvent(e.data)
		}
		window.addEventListener('message', handler)
		return () => window.removeEventListener('message', handler)
	}, [onEvent])

	const src =
		`https://demo.arcade.software/${id}` +
		`?embed&embed_desktop=${desktop}&embed_mobile=${mobile}` +
		`&show_copy_link=true`

	return (
		<div className="relative w-full" style={{ aspectRatio: ratio, minHeight: '600px' }}>
			{isLoading && (
				<div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-t-2xl">
					<div className="flex flex-col items-center">
						<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
						<p className="mt-4 text-gray-600">Loading demo...</p>
					</div>
				</div>
			)}
			<iframe
				ref={ref}
				src={src}
				title={title}
				loading="lazy"
				allow="clipboard-write; fullscreen"
				allowFullScreen
				onLoad={() => setIsLoading(false)}
				style={{ aspectRatio: ratio, minHeight: '600px' }}
				className={`w-full rounded-t-2xl shadow-2xl ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
			/>
		</div>
	)
}

export default ArcadeEmbed
